import React from 'react';
import Body from './components/Body/Body';
import './App.css';

function App() {
  return (
    <div className="App">
      <Body/>
    </div>
  );
}

export default App;
